(function() {
  function waitForEmbla(callback) {
    if (typeof EmblaCarousel !== 'undefined' && typeof EmblaCarouselAutoplay !== 'undefined') callback();
    else setTimeout(() => waitForEmbla(callback), 100);
  }

  function setupUI(wrapper, embla) {
    if (!embla) return;
    const prevBtn = wrapper.querySelector('.embla__prev, .embla__button--prev');
    const nextBtn = wrapper.querySelector('.embla__next, .embla__button--next');
    const progressBar = wrapper.querySelector('.embla__progress__bar, .progress-bar-fill');
    const dotsNode = wrapper.querySelector('.embla__dots');

    const toggleButtons = () => {
      if (!embla.canScrollPrev) return;
      if (prevBtn) prevBtn.disabled = !embla.canScrollPrev();
      if (nextBtn) nextBtn.disabled = !embla.canScrollNext();
    };

    if (prevBtn) { prevBtn.onclick = null; prevBtn.onclick = () => embla.scrollPrev(); }
    if (nextBtn) { nextBtn.onclick = null; nextBtn.onclick = () => embla.scrollNext(); }

    if (progressBar) {
      const updateProgress = () => {
        if (!embla.scrollProgress) return;
        const progress = embla.scrollProgress();
        progressBar.style.width = (Math.max(0, Math.min(1, progress)) * 100) + '%';
      };
      
      embla.off('scroll', updateProgress).off('select', updateProgress).off('reInit', updateProgress);
      embla.on('scroll', updateProgress).on('select', updateProgress).on('reInit', updateProgress);
      setTimeout(updateProgress, 50);
    }

    // ==========================================
    // DYNAMIC DOTS GENERATION & UPDATE LOGIC
    // ==========================================
    if (dotsNode) {
      let dots = [];

      const setupDots = () => {
        dotsNode.innerHTML = '';
        const scrollSnaps = embla.scrollSnapList();
        
        dots = scrollSnaps.map((_, index) => {
          const dot = document.createElement('button');
          dot.classList.add('embla__dot');
          dot.type = 'button';
          dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
          dot.addEventListener('click', () => embla.scrollTo(index));
          dotsNode.appendChild(dot);
          return dot;
        });
        updateDots();
      };

      const updateDots = () => {
        const selected = embla.selectedScrollSnap();
        dots.forEach((dot, index) => {
          if (index === selected) {
            dot.classList.add('embla__dot--selected');
          } else {
            dot.classList.remove('embla__dot--selected');
          }
        });
      };

      embla.off('init', setupDots).off('reInit', setupDots).off('select', updateDots);
      embla.on('init', setupDots).on('reInit', setupDots).on('select', updateDots);
      
      setupDots();
    }
    
    embla.off('select', toggleButtons).off('init', toggleButtons).off('reInit', toggleButtons);
    embla.on('select', toggleButtons).on('init', toggleButtons).on('reInit', toggleButtons);
    setTimeout(toggleButtons, 50);
  }

  function initAllSliders(container = document) {
    
    // ==========================================
    // 1. STANDARD SLIDERS
    // ==========================================
    container.querySelectorAll('[data-embla-slider]').forEach(wrap => {
      if (wrap.classList.contains('embla-initialized')) return;
      const view = wrap.querySelector('.embla__viewport, [data-embla-viewport], [data-testimonial-carousel]');
      const emblaContainer = view ? view.querySelector('.embla__container') : null;
      if (!view || !emblaContainer) return; 

      const autoplay = wrap.getAttribute('data-autoplay') === 'true';
      const speed = parseInt(wrap.getAttribute('data-speed')) || 5;
      const loop = wrap.getAttribute('data-loop') === 'true';
      const align = wrap.getAttribute('data-align') || 'start';

      const options = { loop: loop, align: align, containScroll: align === 'center' ? false : 'trimSnaps' };
      
      const prevBtn = wrap.querySelector('.embla__prev, .embla__button--prev');
      const nextBtn = wrap.querySelector('.embla__next, .embla__button--next');
      const progressBar = wrap.querySelector('.embla__progress__bar, .progress-bar-fill');
      const progressContainer = progressBar ? (progressBar.closest('.embla__progress') || progressBar.parentElement) : null;
      const dotsNode = wrap.querySelector('.embla__dots');

      let emblaInstance = null;
      let isStaticState = null;
      let autoPlayInterval = null;

      const stopAutoPlay = () => {
        if (autoPlayInterval) {
          clearInterval(autoPlayInterval);
          autoPlayInterval = null;
        }
      };

      const startAutoPlay = () => {
        stopAutoPlay();
        autoPlayInterval = setInterval(() => {
          if (!emblaInstance) return;
          if (emblaInstance.canScrollNext()) emblaInstance.scrollNext();
          else emblaInstance.scrollTo(0);
        }, speed * 1000);
      };

      const manageSliderState = () => {
        const slides = emblaContainer.children;
        if (slides.length === 0) return;

        const viewWidth = view.getBoundingClientRect().width;
        const slideWidth = slides[0].getBoundingClientRect().width;

        if (viewWidth === 0 || slideWidth === 0) {
          wrap.retryCount = (wrap.retryCount || 0) + 1;
          if (wrap.retryCount < 15) setTimeout(manageSliderState, 150);
          return;
        }

        const visibleCount = Math.round(viewWidth / slideWidth);
        const shouldBeStatic = slides.length <= visibleCount;

        if (isStaticState === shouldBeStatic && emblaInstance != null) return;
        isStaticState = shouldBeStatic;

        if (shouldBeStatic) {
          stopAutoPlay();
          if (emblaInstance) {
            emblaInstance.destroy();
            emblaInstance = null;
            wrap._embla = null;
          }
          emblaContainer.removeAttribute('style');
          Array.from(slides).forEach(slide => slide.removeAttribute('style'));
          wrap.classList.add('slider-is-static');
          if (prevBtn) prevBtn.style.display = 'none';
          if (nextBtn) nextBtn.style.display = 'none';
          if (progressContainer) progressContainer.style.display = 'none';
          if (dotsNode) dotsNode.style.display = 'none';

        } else {
          wrap.classList.remove('slider-is-static');
          if (prevBtn) prevBtn.style.display = '';
          if (nextBtn) nextBtn.style.display = '';
          if (progressContainer) progressContainer.style.display = '';
          if (dotsNode) dotsNode.style.display = '';

          if (!emblaInstance) {
            emblaInstance = EmblaCarousel(view, options);
            wrap._embla = emblaInstance;
            setupUI(wrap, emblaInstance);
            
            if (autoplay) {
              startAutoPlay();
              wrap.addEventListener('mouseenter', stopAutoPlay);
              wrap.addEventListener('mouseleave', startAutoPlay);
              emblaInstance.on('reInit', () => {
                startAutoPlay();
              });
            }
          }
        }
      };

      wrap._manageState = manageSliderState; 
      wrap._stopAutoplay = stopAutoPlay;
      setTimeout(manageSliderState, 50);
      window.addEventListener('resize', () => setTimeout(manageSliderState, 150));

      wrap.classList.add('embla-initialized');
    });

    // ==========================================
    // 2. TABBED SLIDERS
    // ==========================================
    container.querySelectorAll('[data-embla-tabs-section]').forEach(sectionNode => {
      if (sectionNode.classList.contains('embla-initialized')) return;
      const tabBtns = sectionNode.querySelectorAll('.tab-btn, [data-tab-btn]');
      const tabPanels = sectionNode.querySelectorAll('.tab-panel, [data-tab-panel]');
      let emblaInstances = {};

      tabPanels.forEach(panel => {
        const emblaNode = panel.querySelector('.embla');
        const panelId = panel.id || panel.getAttribute('data-panel-id');
        if (emblaNode && panelId) {
          emblaInstances[panelId] = EmblaCarousel(emblaNode, { loop: false, align: 'start', containScroll: 'trimSnaps' });
        }
      });

      sectionNode._emblaInstances = emblaInstances; 

      const getActiveEmbla = () => {
        const activePanel = sectionNode.querySelector('.tab-panel.active, [data-tab-panel].active');
        return activePanel ? emblaInstances[activePanel.id || activePanel.getAttribute('data-panel-id')] : null;
      };

      if (getActiveEmbla()) setupUI(sectionNode, getActiveEmbla());

      tabBtns.forEach(btn => {
        btn.addEventListener('click', function() {
          tabBtns.forEach(b => b.classList.remove('active'));
          tabPanels.forEach(p => p.classList.remove('active'));
          this.classList.add('active');
          
          const targetId = this.getAttribute('data-target');
          const targetPanel = sectionNode.querySelector('#' + targetId) || sectionNode.querySelector(`[data-panel-id="${targetId}"]`);
          
          if(targetPanel) {
            targetPanel.classList.add('active');
            if(emblaInstances[targetId]) { 
              emblaInstances[targetId].reInit();
              setupUI(sectionNode, emblaInstances[targetId]); 
            }
          }
        });
      });
      sectionNode.classList.add('embla-initialized');
    });

    // ==========================================
    // 3. SYNCED SLIDERS
    // ==========================================
    container.querySelectorAll('[data-embla-synced]').forEach(wrapper => {
      if (wrapper.classList.contains('embla-initialized')) return;
      const textNode = wrapper.querySelector('[id^="embla-text-"], .embla-text-node');
      const imageNode = wrapper.querySelector('[id^="embla-image-"], .embla-image-node');
      if(!textNode || !imageNode) return;

      const emblaText = EmblaCarousel(textNode, { loop: false, duration: 40 });
      const emblaImage = EmblaCarousel(imageNode, { loop: false, duration: 40 });

      wrapper._emblaSynced = { text: emblaText, image: emblaImage }; 

      const updateActiveClasses = () => {
        if (!emblaText.slideNodes) return;
        const selected = emblaText.selectedScrollSnap();
        emblaText.slideNodes().forEach((node, i) => node.classList.toggle('is-active', i === selected));
        emblaImage.slideNodes().forEach((node, i) => node.classList.toggle('is-active', i === selected));
      };
      emblaText.on('select', updateActiveClasses).on('init', updateActiveClasses);
      emblaText.on('select', () => emblaImage.scrollTo(emblaText.selectedScrollSnap()));
      emblaImage.on('select', () => emblaText.scrollTo(emblaImage.selectedScrollSnap()));

      setupUI(wrapper, emblaText);
      wrapper.classList.add('embla-initialized');
    });
  }

  document.addEventListener('shopify:section:load', (e) => setTimeout(() => initAllSliders(e.target), 50));
  
  waitForEmbla(() => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAllSliders(document));
    else initAllSliders(document);
  });

  const observer = new MutationObserver(function(mutations) {
    let needsInit = false;
    for (let mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        if (mutation.target.tagName === 'PRODUCT-RECOMMENDATIONS') {
          needsInit = true; break;
        }
        for (let node of mutation.addedNodes) {
          if (node.nodeType === 1 && (node.tagName === 'PRODUCT-RECOMMENDATIONS' || node.hasAttribute('data-embla-slider'))) {
            needsInit = true; break;
          }
        }
      }
    }
    if (needsInit) setTimeout(() => initAllSliders(document), 100);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // =================================================================
  // 4. TAB WAKE-UP CALL
  // =================================================================
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      
      document.querySelectorAll('[data-embla-slider]').forEach(wrap => {
        wrap.retryCount = 0; 
        if (wrap._stopAutoplay) wrap._stopAutoplay();
        if (wrap._manageState) wrap._manageState();
        if (wrap._embla) wrap._embla.reInit();
      });

      document.querySelectorAll('[data-embla-tabs-section]').forEach(section => {
        if (section._emblaInstances) {
          Object.values(section._emblaInstances).forEach(inst => inst.reInit());
        }
      });

      document.querySelectorAll('[data-embla-synced]').forEach(wrap => {
        if (wrap._emblaSynced) {
          wrap._emblaSynced.text.reInit();
          wrap._emblaSynced.image.reInit();
        }
      });

    } else if (document.visibilityState === 'hidden') {
      document.querySelectorAll('[data-embla-slider]').forEach(wrap => {
        if (wrap._stopAutoplay) wrap._stopAutoplay();
      });
    }
  });
})();

let isDragging = false;
document.querySelectorAll('.embla__slide[data-slide-link]').forEach((slide) => {
  slide.addEventListener('mousedown', () => {
    isDragging = false;
  });

  slide.addEventListener('mousemove', () => {
    isDragging = true;
  });

  slide.addEventListener('click', (e) => {
    if (isDragging) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    window.location.href = slide.dataset.slideLink;
  });
});